






















import { defineComponent, ref, watch } from '@vue/composition-api';
import { AkkadianLetterGroupsUpper } from '@oare/oare';
import useQueryParam from '@/hooks/useQueryParam';

export default defineComponent({
  name: 'OareLetterFilter',
  props: {
    letter: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
    filterTitle: {
      type: String,
      default: 'words',
    },
  },
  setup(props, { emit }) {
    const letters = ref(Object.keys(AkkadianLetterGroupsUpper));
    const wordSearch = useQueryParam('filter', '', true);
    const encodedLetter = (letter: string) => encodeURIComponent(letter);

    watch(
      () => props.letter,
      () => (wordSearch.value = ''),
      { immediate: false }
    );

    watch(wordSearch, () => emit('search-input', wordSearch.value), {
      immediate: true,
    });

    return {
      letters,
      wordSearch,
      encodedLetter,
    };
  },
});
